import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { INotification } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class NotificationApiService {

  abstract getList(): Observable<INotification[]>;
  abstract getContactNotifications(contactId: String): Observable<INotification[]>;
  abstract saveAssociateNotificationWithContact(contactId: String,notificationId: String): Observable<INotification[]>;

}